import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import Textarea from 'react-textarea-autosize';
// import Phone, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import moment from 'moment';

// Components
import TimeSelect2 from '../Modules/TimeSelect2';

const IncidentForm = observer(class IncidentForm extends React.Component {
  constructor() {
    super();
    this.handleInput = this.handleInput.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePhoneInput = this.handlePhoneInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.cancelIncident = this.cancelIncident.bind(this);
  }

  componentWillMount() {
    const { profile, userData } = this.props.store.SessionStore;

    this.state = {
      date: null,
      incidentData: {
        subject: '',
        details: '',
        status: 'Open',
        eventTime: null,
        potentialDamage: '',
        correctiveActionDetails: '',
        directWitness: '',
        contactPerson: `${userData.firstName} ${userData.lastName}`,
        contactPhone: profile.phoneNumber,
        contactEmail: userData.email,
        eventTypeSid: '',
        draft: true
      }
    }

    this.props.store.ExamStore.getIncidentTypes();

    // If we’re editing an incident, get its data
    if(this.props.store.ExamStore.incidentSid) {

      this.props.store.ExamStore.getSingleSessionEvent(
        this.props.installSid,
        this.props.examSid,
        this.props.store.ManagerStore.incidentSession,
        this.props.store.ExamStore.incidentSid,
        this
      )
      .then(response => {
        this.setState({incidentData: response})

      })
    }
  }

  handleInput() {
    let incidentData = {...this.state.incidentData};

    incidentData.subject = this.subject.value || '';
    incidentData.details = this.details.value || '';
    incidentData.potentialDamage = this.potentialDamage.value || '';
    incidentData.correctiveActionDetails = this.correctiveActionDetails.value || '';
    incidentData.directWitness = this.directWitness.value || '';
    // incidentData.contactPerson = this.contactPerson.value || '';
    // incidentData.contactEmail = this.contactEmail.value || '';
    incidentData.eventTypeSid = this.eventTypeSid.value || '';

    this.setState({
      incidentData
    });
  }

  handleDateChange(date, isDateField) {
    if(isDateField) {
      this.setState({
        date
      });
    } else {
      date = this.state.date;
    }

    const time = this.time.value;

    let incidentData = {...this.state.incidentData};
    const dateString = moment(date).format('YYYY-MM-DD HH:mm Z');

    incidentData.eventTime = moment.utc(`${dateString} ${time}`, 'YYYY-MM-DD Z HH:mm').toISOString();

    this.setState({
      incidentData
    });
  }

  handlePhoneInput(e) {
    let incidentData = {...this.state.incidentData};
    incidentData.contactPhone = e;
    this.setState({
      incidentData
    });
  }

  handleSubmit() {
    const { session } = this.props.store.ScheduleStore;
    const { installSid, examSid, sid } = session;

    if(this.props.store.ExamStore.incidentSid) {
      // If we’re editing an incident, update it
      this.props.store.ExamStore.updateSessionEvent(
        installSid,
        examSid,
        sid,
        this.props.store.ExamStore.incidentSid,
        this.state.incidentData,
        this.props.complete('incident')
      );
    } else {
      // Otherwise, create a new one
      this.props.store.ExamStore.createSessionEvent(
        installSid,
        examSid,
        sid,
        this.state.incidentData,
        this.props.complete('incident')
      );
    }
  }

  cancelIncident() {
    this.props.store.ManagerStore.reportIncident = false;
  }

  render() {
    const { translation } = this.props;
    const { ExamStore, SessionStore } = this.props.store;

    if(!SessionStore.loading && ExamStore.incidentTypes.length > 0) {
      return (
        <form className="incident-form" onSubmit={(e) => checkValidity(e, this.handleSubmit, '.incident-form')} noValidate>
          <fieldset>
            <ul className="fields">
              <li>
                <label className="lbl-required" htmlFor="incident-subject">{translation.subject}</label>
                <input
                  type="text"
                  id="incident-subject"
                  ref={(input) => {this.subject = input}}
                  onChange={this.handleInput}
                  required
                  aria-required="true"
                  autoFocus
                  defaultValue={this.state.incidentData.subject}
                />
              </li>
              <li className="field--auto">
                <label className="lbl-required" htmlFor="incident-type">{translation.type.label}</label>
                <label className="select" htmlFor="incident-type">
                  <select
                    id="incident-type"
                    ref={(input) => {this.eventTypeSid = input}}
                    onChange={this.handleInput}
                    required
                    aria-required="true"
                    defaultValue={
                      this.state.incidentData.eventType ? this.state.incidentData.eventType.sid : null
                    }
                  >
                    <option value="">{translation.type.helper}</option>
                    {ExamStore.incidentTypes.map(
                      (key, i) =>
                      <option key={i} value={key.sid}>
                        {key.title.charAt(0).toUpperCase() + key.title.slice(1)}
                      </option>
                    )}
                  </select>
                </label>
              </li>
              <li className="field--auto">
                <label className="lbl-required" htmlFor="incident-date">{translation.date.label}</label>

                <DatePicker
                  id="incident-date"
                  selected={this.props.store.ExamStore.incidentSid ? new Date(moment(this.state.date)) : this.state.date}
                  onChange={(date) => {this.handleDateChange(date, true)}}
                  placeholderText={translation.date.helper}
                  required
                  aria-required="true"
                  ref={(input) => {this.eventTime = input}} />

                <span className="preposition">{translation.date.at}</span>

                <label className="select" htmlFor="incident-time">
                  <select
                    id="incident-time"
                    ref={(input) => {this.time = input}}
                    onChange={() => this.handleDateChange(null, false)}
                    defaultValue={moment.utc(ExamStore.incident.eventTime).local().format('HH:mm')}
                  >
                    <TimeSelect2 />
                  </select>
                </label>
              </li>
              <li>
                <label className="lbl-optional" htmlFor="incident-details">{translation.details}</label>
                <Textarea
                  id="incident-details"
                  className="textarea-grow"
                  ref={(input) => {this.details = input}}
                  onChange={this.handleInput}
                  defaultValue={this.state.incidentData.details}
                ></Textarea>
              </li>
              <li>
                <label className="lbl-optional" htmlFor="incident-damage" aria-describedby="damage-tooltip">
                  {translation.potential_damage.label}

                  <div className="tooltip">
                    <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                    <div id="damage-tooltip" className="tooltip__body" role="tooltip">
                      {translation.potential_damage.tooltip}
                    </div>
                  </div>
                </label>

                <Textarea
                  id="incident-damage"
                  className="textarea-grow"
                  ref={(input) => {this.potentialDamage = input}}
                  onChange={this.handleInput}
                  defaultValue={this.state.incidentData.potentialDamage}
                ></Textarea>
              </li>
              <li>
                <label className="lbl-optional" htmlFor="incident-action">{translation.corrective_action}</label>
                <Textarea
                  id="incident-action"
                  className="textarea-grow"
                  ref={(input) => {this.correctiveActionDetails = input}}
                  onChange={this.handleInput}
                  defaultValue={this.state.incidentData.correctiveActionDetails}
                  maxLength="255"
                ></Textarea>
              </li>
              <li>
                <label className="lbl-required" htmlFor="incident-witness" aria-describedby="witness-tooltip">
                  {translation.direct_witness.label}

                  <div className="tooltip">
                    <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                    <div id="witness-tooltip" className="tooltip__body" role="tooltip">
                      {translation.direct_witness.tooltip}
                    </div>
                  </div>
                </label>

                <input
                  type="text"
                  id="incident-subject"
                  ref={(input) => {this.directWitness = input}}
                  onChange={this.handleInput}
                  required
                  aria-required="true"
                  defaultValue={this.state.incidentData.directWitness}
                />
              </li>
              {/* <li>
                <label className="lbl-required" htmlFor="incident-person">{translation.contact_person}</label>
                <input
                  type="text"
                  id="incident-person"
                  ref={(input) => {this.contactPerson = input}}
                  onChange={this.handleInput}
                  required
                  aria-required="true"
                />
              </li>
              <li>
                <label className="lbl-required" htmlFor="incident-phone">{translation.contact_phone}</label>
                <Phone
                  id="incident-phone-tel"
                  nativeExpanded={true}
                  flagsPath="./static/img/flags/"
                  country={parsePhoneNumber(this.state.incidentData.contactPhone).country || 'US'}
                  value={this.state.incidentData.contactPhone}
                  ref={(input) => {this.contactPhone = input}}
                  onChange={e => this.handlePhoneInput(e)}
                  required
                  aria-required="true"
                  aria-invalid={!isValidPhoneNumber(this.state.incidentData.contactPhone)}
                />
              </li>
              <li>
                <label className="lbl-required" htmlFor="incident-email">{translation.contact_email}</label>
                <input
                  type="email"
                  id="incident-email"
                  ref={(input) => {this.contactEmail = input}}
                  onChange={this.handleInput}
                  required
                  aria-required="true"
                />
              </li> */}
            </ul>
          </fieldset>

          <button className="btn" type="submit">{translation.button}</button>

          <span className="preposition preposition--vertical">{translation.or}</span>

          <button className="btn--link" type="button" onClick={this.cancelIncident}>{translation.cancel}</button>
        </form>
      )
    }

    return null;
  }
})

export default translate('IncidentForm')(IncidentForm);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/IncidentForm.js